import oRequest from "@/libsV2/request";
import {Toast} from 'vant'

const URL = {
    TAG_LIST: "design/discuss/tag",  //评价标签
    EVA_ADD:'design/discuss/add',//提交评价
    EVA_INFO:'design/discuss/info',//评价详情
};
export const evaInfo = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.EVA_INFO, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};
export const tagList = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.TAG_LIST, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};
export const evaAdd = (data = {}) => {
    return new Promise((resolve, reject) => {
        oRequest.getData(URL.EVA_ADD, data).then((res) => {
            if (res.data.error == 0) {
                resolve(res.data)
            } else {
                Toast(res.data.msg)
                reject(res)
            }
        }).catch((err) => {
            reject(err)
        })
    });
};


